/**
 * 解析 ULD 批量接口返回。后端统一信封是 { success, message, data }，
 * data 里才有 success_count；有的调用方误把外层当成结果。
 */
export function unwrapBatchOperationResult(response) {
    const envelope = response?.data;
    if (!envelope || typeof envelope !== "object") {
        return { success_count: 0, failure_count: 0, failure_items: [] };
    }

    const inner = envelope.data;
    if (inner && typeof inner === "object" && typeof inner.success_count === "number") {
        return inner;
    }

    if (typeof envelope.success_count === "number") {
        return envelope;
    }

    return { success_count: 0, failure_count: 0, failure_items: [] };
}

export function didBatchSucceed(result) {
    return (result?.success_count || 0) > 0;
}
